// import logo from './logo.svg';
import './App.css';
import AllRouter from './components/Pages/AllRouter';

function App() {
  return (
    <div className="App">
      <AllRouter/>
    </div>
  );
}

export default App;

